module.exports = __webpack_public_path__ + "static/media/mercedes-9.ba512150.jpg";